var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companyListBox"},[_c('el-table',{attrs:{"data":_vm.tableData,"border":""},on:{"row-click":_vm.goToProductInfo}},[_c('el-table-column',{attrs:{"prop":"securityCode","label":"证券代码"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"securityName","label":"证券简称"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03979c5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companyList.vue
// module id = null
// module chunks = 